module.exports = __webpack_public_path__ + "assets/img/f5aa-id.svg";